<template>
  <ModalBox :class="[forgotEmailSent ? 'd-flex justify-content-center h-100' : '']">
    <div
      v-if="!forgotEmailSent"
      class="d-flex flex-column align-items-center"
    >
      <h3>{{ incorrectPin ? 'Incorrect PIN' : 'Enter PIN' }}</h3>

      <CodeInput
        ref="pin"
        :loading="false"
        :fields="4"
        :required="true"
        type="password"
        class="input"
        @complete="onCompletePin"
        @change="onChangePin"
      />
      <VsButton
        :disabled="disableButton"
        class="btn__action mt-4"
        @click="submitPin"
        @keyup.enter="submitPin"
      >
        Submit
      </VsButton>
      <VsButton
        v-if="incorrectPin"
        style="color: #CB225C"
        :loading="loading"
        @click="forgotPin"
      >
        {{ $t('profileSettings.form.settings.pin.forgot-pin') }}
      </VsButton>
    </div>
    <div
      v-if="forgotEmailSent"
      class="d-flex justify-content-center align-items-center flex-column"
    >
      <h4>
        {{ $t('profileSettings.form.settings.pin.message.reset-email') }}
      </h4>
      <VsButton
        class="btn__action mt-4"
        @click="$emit('close')"
      >
        Close
      </VsButton>
    </div>
  </ModalBox>
</template>

<script lang="ts">
import Vue from 'vue';
import CodeInput from 'vue-verification-code-input';
import * as VideoStore from '@/scripts/store/modules/video';
import ModalBox from '@/scripts/Components/Organisms/ModalBox.vue';
import VsButton from '@/scripts/Components/Molecules/VsButton.vue';

import { videosApi } from '@/scripts/webcall/v3/videos';
import { meApi } from '@/scripts/webcall/v3/me';

export default Vue.extend({
  components: {
    ModalBox,
    VsButton,
    CodeInput,
  },
  data() {
    return {
      pin: '' as string,
      pinInput: [] as Array<string>,
      incorrectPin: false as boolean,
      forgotEmailSent: false as boolean,
      loading: false as boolean,
      disableButton: true as boolean,
    };
  },
  methods: {
    checkContentWatchability: VideoStore.mapAction('checkContentWatchability'),
    removeOverlay: VideoStore.mapMutation('removeAllVideoPlayerOverlay'),
    setCanWatch: VideoStore.mapMutation('setCanWatch'),
    setBlockingError: VideoStore.mapMutation('setVideoPlayerError'),

    async submitPin(): Promise<void> {
      const params = window.location.pathname.split('/');
      await videosApi.getCanWatchWithPin({ videoId: params[params.length-1] }, undefined, { pin: this.pin }).then((response) => {
        if (response.data.status === 'incorrect_pin') {
          this.incorrectPin = true;
          this.disableButton = true;
        } else {
          this.incorrectPin = false;
          this.removeOverlay();
          this.setBlockingError(null);
          this.setCanWatch(true);
          this.$emit('close');
        }
      });
      this.pin = '';
    },

    onCompletePin(inputPin: string): void {
      this.pin = inputPin;
      this.disableButton= false;
    },
    onChangePin(): void{
      this.disableButton =true;
    },
    async forgotPin(): Promise<void> {
      this.loading = true;
      await meApi.profile.SendPinReset(undefined, undefined, { platform: 'web' }).then(() => {
        this.forgotEmailSent = true;
        this.loading = false;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/exports/_component-entry';
.btn__action {
  font-size: 16px;
  font-weight: 700;
  padding: 4px 12px;
  margin: 0 12px;
  &.disabled {
    pointer-events: none;
    background-color: transparent;
  }
}

</style>
